<template>
  <v-layout column fill-height>
    <div :id="id" :style="`height: 100%; width: 100%; backgroundImage: url(${this.getPlan}); backgroundSize: 100%;`">
    </div>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import uid from '@/nms/components/utils/uid'

// Типы для данных
interface PlanData {
  [key: string]: any
}

interface PlanItem {
  url?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'PLAN',

  props: {
    data: {
      type: Object as () => PlanData,
      default: () => ({})
    },
    plan: {
      type: Array as () => PlanItem[],
      default: () => []
    },
  },

  data(): {
    id: string | null
  } {
    return {
      id: null,
    }
  },

  computed: {
    getPlan(): string | undefined {
      if (!this.plan.length) return undefined
      return this.plan[0].url
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    this.getBackground()
  },

  methods: {
    setup(): void {
      this.id = uid('plan')
    },

    getBackground(): void {
      const plan = this.getPlan
      if (!plan) return
      // TODO: реализовать загрузку фона
    },
  },
})
</script>

<style lang="css" scoped>
</style>
